import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { NL } from '../i18n/nl';
import { EN } from '../i18n/en';
import { resolvePath, switchLangPath, langFromPath } from '../i18n/routes';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);
  const c = lang === 'en' ? EN : NL;

  const lp = (key, params) => resolvePath(lang, key, params);
  const otherLangPath = (target) => switchLangPath(pathname, target);

  return (
    <LanguageContext.Provider value={{ lang, c, ui: c.ui, lp, otherLangPath }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};
